








































import type { AtributoMarketplace, Page, Pageable, TipoAtributoMarketplace } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindAtributoMarketplaceUseCase } from '@/usecases/marketplace/FindAtributoMarketplaceUseCase'
import axios, { CancelTokenSource } from 'axios'
import { ObserveVisibility } from 'vue-observe-visibility'
import { Vue, Component, Watch, Prop, PropSync } from 'vue-property-decorator'
import { DataOptions } from 'vuetify'

@Component({
	directives: {
		ObserveVisibility,
	},
})
export default class SeletorDeAtributoMarketplace extends Vue {
	@PropSync('value', { default: null }) atributo!: AtributoMarketplace
	@Prop() tipoAtributo!: TipoAtributoMarketplace
	atributos: AtributoMarketplace[] = []
	busca = ''
	buscandoNovosItens = false
	cancelToken: CancelTokenSource | null = null
	pagina: Page<AtributoMarketplace> | null = null
	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}
	
	findAtributoMarketplaceUseCase =  new FindAtributoMarketplaceUseCase()

	get atributosFormatados() {
		if (this.atributo && this.atributos.length === 0) {
			return [this.atributo]
		}

		if (this.pagina && !this.pagina.last && !this.buscandoNovosItens) {
			if (this.atributo && this.atributos.findIndex(atributo => atributo.idExterno === this.atributo.idExterno) === -1) {
				this.atributos.push(this.atributo)
			}

			return [
				...this.atributos,
				...[{ tipo: 'buscar-mais' }],
			]
		}
		return this.atributos
	}

	@Watch('atributo')
	onAtributoChange(novoValor: AtributoMarketplace | null, valorAntigo: AtributoMarketplace | null) {
		if (!novoValor && valorAntigo) {
			this.busca = ''
			this.atributos = []
			this.paginacao.page = 0
		}
	}

	@Watch('busca')
	async onChangeBusca() {
		if (this.atributo) return

		this.paginacao.page = 0

		this.atributos = await this.buscar({
			...this.paginacao,
		})
	}

	async buscarNovosItens() {
		if (this.atributo) return
		this.buscandoNovosItens = true
		const atributosNovos = await this.buscar({
			...this.paginacao,
			page: this.paginacao.page + 1,
		})

		this.atributos = [
			...this.atributos,
			...atributosNovos,
		]
		this.buscandoNovosItens = false
	}

	async buscar(paginavel: Pageable) {
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			if (this.atributo) this.busca = this.atributo.descricao

			this.pagina = await this.findAtributoMarketplaceUseCase.findAllAtributos({
				busca: this.busca || undefined,
				tipoAtributo: this.tipoAtributo || undefined,
				page: paginavel.page || 0,
				size: paginavel.size || 10,
			}, axiosConfig);
			this.paginacao.page = this.pagina.number

			return this.pagina.content
		} catch (e) {
			if (axios.isCancel(e)) throw e
			AlertModule.setError(e)
			throw e
		}
	}

	mudouVisibilidade(visivel) {
		if (visivel && !this.buscandoNovosItens) this.buscarNovosItens()
	}

	filtrar(item: any, queryText, itemText) {
		if (item.tipo === 'header') return false

		const hasValue = val => (val ? val : '')
		const textLower = hasValue(itemText).toString().toLowerCase()
		const queryLower = hasValue(queryText).toString().toLowerCase()

		if (item.tipo === 'buscar-mais') return this.pagina && !this.pagina.last

		return textLower.includes(queryLower)
	}
}
